import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TrendsChart from './TrendsViewCharts/Trendchart';
import CalendarView from './components/CalendarView';

const LineChartToggle = ({ dates }) => {
  const [view, setView] = useState('trends');

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  const renderActiveView = () => {
    switch (view) {
      case 'trends':
        return <TrendsChart dates={dates} />;
      case 'calendar':
        return <CalendarView onClick={(day, month, year) => {
          console.log(`Selected date: ${day}/${month + 1}/${year}`);
          // Handle date selection here
        }} />;
      default:
        return <TrendsChart dates={dates} />;
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleViewChange}
          aria-label="view selector"
        >
          <ToggleButton value="trends" aria-label="trends view">
            <TimelineIcon sx={{ mr: 1 }} />
            Trends View
          </ToggleButton>
          {/* <ToggleButton value="calendar" aria-label="calendar view">
            <CalendarMonthIcon sx={{ mr: 1 }} />
            Calendar View
          </ToggleButton> */}
        </ToggleButtonGroup>
      </Box>
      {renderActiveView()}
    </Box>
  );
};

LineChartToggle.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default LineChartToggle;
